"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "motion/react";
import type { PostDetails } from "@/types/posts";
import { ProjectDetail } from "@/types/projects";
import { BreakoutWrapper } from "@/ui/atoms/breakout-wrapper";
import { CarouselWithFade } from "@/ui/carousel";
import ArLogoParticles from "@/ui/particle/temp";
import { PostCards } from "@/ui/post-cards";
import { ProjectCards } from "@/ui/project-cards";
import LandingPageTypeWriter from "@/ui/typewriter";
import { WorldTourLayout } from "@/ui/world-tour";
export function HomeContent(t0) {
  const $ = _c(12);
  const {
    posts,
    projects
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <motion.div initial={false} transition={{
      duration: 0.5,
      ease: "easeInOut"
    }} className="fixed inset-0 z-[-1]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section><LandingPageTypeWriter /></section>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="mx-auto my-12"><BreakoutWrapper><CarouselWithFade /></BreakoutWrapper></section>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== projects) {
    t4 = <section><ProjectCards projects={projects} /></section>;
    $[3] = projects;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section><BreakoutWrapper><ArLogoParticles /></BreakoutWrapper></section>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== posts) {
    t6 = <section><PostCards posts={posts} /></section>;
    $[6] = posts;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <WorldTourLayout />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t6) {
    t8 = <div className="theme-transition 2xl:max-w-8xl mx-auto flex max-w-3xl flex-col items-center justify-center pt-24 pb-16 sm:max-w-7xl sm:px-4 lg:px-6">{t1}<div className="theme-transition space-y-12">{t2}{t3}{t4}{t5}{t6}{t7}</div></div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}